import { Link } from 'react-router-dom';

export function Brand({ inverse = false }) {
  return (
    <Link className={`brand ${inverse ? 'brand--inverse' : ''}`} to="/">
      <img
        className="brand__logo"
        src="/branding/logo2.png"
        alt="Sawwari — Your city. Your ride."
      />
    </Link>
  );
}
